export const money = (v: unknown) => (Number(v ?? 0) || 0).toFixed(2);
